import { DefinedUseQueryResult, useQuery } from "@tanstack/react-query";
import React from "react";
import { GET_SCREEN_ROUTE } from "../querykeys";
import { request } from "../api";
import { BaseResponse } from "../types/baseRespones";
import { Screen } from "../types/screen";

const useScreenList = (): DefinedUseQueryResult<Screen[], Error> => {
  return useQuery({
    queryKey: [GET_SCREEN_ROUTE],
    queryFn: async () => {
      const result = await request<BaseResponse<Screen[]>>({
        method: "GET",
        url: "/stm-screen/route",
      });

      return result.data || [];
    },
    initialData: [],
  });
};

export default useScreenList;
